import React from "react";
import SearchModalContent from "./SearchModalContent";

export interface SearchModalProps {
	/** Whether the modal is open */
	isOpen: boolean;
	/** Callback to close the modal */
	onClose: () => void;
	/** Placeholder text for the search input */
	placeholder?: string;
	/** Optional title for the modal */
	title?: string;
	/** Optional CSS class name */
	className?: string;
}

/**
 * SearchModal - Modal dialog for search functionality
 *
 * This component provides a modal interface for search operations.
 * It's designed to be controlled by parent state and can be easily
 * extended with actual search logic.
 *
 * Key features:
 * - Controlled open/close state
 * - Escape key and backdrop click to close
 * - Focus management for accessibility
 * - Clean, extensible structure
 *
 * Future extensions:
 * - Portal rendering for proper DOM placement
 * - Animation on enter/exit
 * - Search history display
 * - Recent searches
 * - Filter controls
 * - Results preview
 */
const SearchModal: React.FC<SearchModalProps> = (props) => {
	if (!props.isOpen) return null;
	return <SearchModalContent {...props} />;
};

export default SearchModal;
